export const ERROR_MESSAGES = {
  400: 'Unable to process the request at the moment',
  401: 'Your are not authorized to access this application. Please try to login again',
  403: 'Your access is not authorized',
  404: 'Data not available',
  500: 'Technical issue, please try again later',
  502: 'Technical issue, please try again later',
  503: 'Technical issue, please try again later',
  504: 'Service took too long to respond. Please try again after some time',
};

export default ERROR_MESSAGES;
